import { AxiosInstance } from 'axios'

import { Sale, Sales } from '~/api/modules/sales/types'

import { HttpStatusCode, NotFoundError, Success } from '~/api/results'

export function createSalesModule({
  axios,
  sentry,
  city,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
}) {
  return {
    async fetchSales() {
      try {
        const { data } = await axios.get<Sales>(`/${city}/promotions/`)

        return new Success(data)
      } catch (error) {
        sentry.captureException(error)
        return new Error('Что-то пошло не так')
      }
    },
    async fetchSale(saleSlug: string) {
      try {
        const { data } = await axios.get<Sale>(
          `/${city}/promotions/${saleSlug}/`,
        )

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Акция не найдена')
          default:
            sentry.captureException(error)
            return new Error('Что-то пошло не так')
        }
      }
    },
  }
}
